import { CompanyStatus } from '../common';

export class BillingDetails {
  companyName: string;
  address: string;
  zipCode: number;
  contactPerson: string;
  contactNumber: string;
  invoiceEmail: string;
}

export class UserBilling {
  userId: number;
  companyId: number;
  companyName: string;
  address: string;
  postalCode: string;
  city: string;
  countryName: string;
  countryId: number;
  contactPerson: string;
  phone: string;
  activatedInfluencers: number;
  managedInfluencers: number;
  accountLevel: string;
  invoicedNextMonth: number;
  maxActivatedInfluencers: number;
  maxManagedInfluencers: number;
  vatid: string;
  dayTrialLeft: number;
  contractRenewalDate: Date;
  status: BillingStatus;
  currency: string;
  isValidPayment: boolean;
  isLoading: boolean;
  canManageSubscription: boolean;
  customerStatus: CompanyStatus;
}

export enum BillingStatus {
  IN_TRIAL = 'IN_TRIAL',
  ACTIVE = 'ACTIVE',
  NON_RENEWING = 'NON_RENEWING',
  CANCELLED = 'CANCELLED'
}

export interface UserMonthlyUsage {
  accountLevelsCustomUsage?: {
    accountLevelsId: number;
    accountLevelsName: string;
    monthlyActiveInfluencers: number;
  };
  monthlyUsage?: {
    termStart: number;
    termEnd: number;
    activeInfluencers: number;
  }[];
  isLoading?: boolean;
  isLoadingError?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/Billing/billing-details.ts